import Page from './page'
import Message from './message'
import MessageBox from './messageBox'
import Select from './select'
import Option from './option'
import Input from './input'
import Switch from './switch'
import Dialog from './dialog'
import ImgCropper from './imgCropper'
import Dropdown from './dropdown'
import Subpage from './subpage'
import Table from './table'
import Form from './form'
import Radio from './radio'
import RadioGroup from './radioGroup'
import Checkbox from './checkbox'
import CheckboxGroup from './checkboxGroup'
import Tree from './tree'
import Autocomplete from './autocomplete'
import InputNumber from './inputNumber'
import TextTips from './textTips'
import Button from './button'
import PageHeader from './pageHeader'
import NoData from './noData'
import LoadingBox from './loadingBox'
import Steps from './steps'
import BackHeader from './backHeader'
import Tabs from './tabs'
import Tooltip from '@/packages/tooltip/src/Tooltip'

export const components = {
  Page,
  Message,
  MessageBox,
  Select,
  Option,
  Input,
  Switch,
  Dialog,
  ImgCropper,
  Dropdown,
  Subpage,
  Table,
  Form,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Tree,
  Autocomplete,
  InputNumber,
  TextTips,
  Button,
  PageHeader,
  NoData,
  LoadingBox,
  Steps,
  BackHeader,
  Tabs,
  Tooltip
}

const install = function(Vue, opts = {}) {
  Object.entries(components).forEach(([key, comp]) => {
    if (typeof comp.install === 'function') {
      Vue.use(comp)
    } else {
      Vue.component(comp.name || key, comp)
    }
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  ...components
}
